import { render, staticRenderFns } from "./ObchodnePriestory.vue?vue&type=template&id=860ad9da&scoped=true"
import script from "./ObchodnePriestory.vue?vue&type=script&lang=js"
export * from "./ObchodnePriestory.vue?vue&type=script&lang=js"
import style0 from "./ObchodnePriestory.vue?vue&type=style&index=0&id=860ad9da&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860ad9da",
  null
  
)

export default component.exports